import script from "./VTable.vue?vue&type=script&setup=true&lang=js"
export * from "./VTable.vue?vue&type=script&setup=true&lang=js"

import "./VTable.vue?vue&type=style&index=0&id=ca61868e&lang=css"

const __exports__ = script;

export default __exports__